import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { AppProviders } from './app/providers';
import { router } from './app/router';
import { env } from './lib/env';
import './styles/global.css';

async function bootstrap(): Promise<void> {
  // Dev-only mock backend; this branch (and msw) is stripped from prod builds.
  if (import.meta.env.DEV && env.useMocks) {
    const { startMockWorker } = await import('./mocks/browser');
    await startMockWorker();
  }

  const rootElement = document.getElementById('root');
  if (!rootElement) throw new Error('Root element #root not found');

  createRoot(rootElement).render(
    <StrictMode>
      <AppProviders>
        <RouterProvider router={router} />
      </AppProviders>
    </StrictMode>,
  );
}

void bootstrap();
